// AUTO-GENERATED FILE - DO NOT EDIT
// Generated by scripts/generate-cube-meta.ts
import type {
  CubeMeasureEntry,
  CubeDimensionEntry,
  CubeJoinEntry
} from 'shared/src/api/cube-api-types';

export const zohosignDocumentsCubeMeta = {
  name: 'zohosign_documents',
  sqlTable: 'media_tool.zohosign_documents',
  title: 'Zohosign Documents',
  joins: {
    campaigns: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry,
    insertion_orders: { relationship: 'many_to_one' } as const satisfies CubeJoinEntry
  },
  measures: {
    'zohosign_documents.count': {
      type: 'number',
      aggType: 'count',
      title: 'Document Count',
      description: 'Number of ZohoSign documents',
      meta: {
        category: 'utility',
        supports_rollup: true,
        formula: 'COUNT(*)',
        inputs: [],
        short_description: 'Number of ZohoSign documents',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeMeasureEntry
  },
  dimensions: {
    'zohosign_documents.id': {
      sql: 'id',
      type: 'string',
      title: 'Document ID',
      primaryKey: true,
      meta: {
        short_description: 'Zoho Sign Document ID',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.name': {
      sql: 'name',
      type: 'string',
      title: 'Document Name',
      meta: {
        short_description: 'Document display name',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_document_status': {
      sql: 'zohosign_document_status',
      type: 'string',
      title: 'Document Status',
      meta: {
        short_description: 'Current signing status of the document',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_date_sent': {
      sql: 'zohosign_date_sent',
      type: 'time',
      title: 'Date Sent',
      meta: {
        short_description: 'Date the document was sent for signing',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_date_completed': {
      sql: 'zohosign_date_completed',
      type: 'time',
      title: 'Date Completed',
      meta: {
        short_description: 'Date the document signing was completed',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_date_declined': {
      sql: 'zohosign_date_declined',
      type: 'time',
      title: 'Date Declined',
      meta: {
        short_description: 'Date the document was declined',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_declined_reason': {
      sql: 'zohosign_declined_reason',
      type: 'string',
      title: 'Declined Reason',
      meta: {
        short_description: 'Reason the document was declined',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_document_deadline': {
      sql: 'zohosign_document_deadline',
      type: 'time',
      title: 'Document Deadline',
      meta: {
        short_description: 'Signing deadline for the document',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_time_to_complete': {
      sql: 'zohosign_time_to_complete',
      type: 'string',
      title: 'Time to Complete',
      meta: {
        short_description: 'Time elapsed to complete signing',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_document_message': {
      sql: 'zohosign_document_message',
      type: 'string',
      title: 'Document Message',
      meta: {
        short_description: 'Message included with the signing request',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_document_note': {
      sql: 'zohosign_document_note',
      type: 'string',
      title: 'Document Note',
      meta: {
        short_description: 'Internal note on the document',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_account': {
      sql: 'zohosign_account',
      type: 'string',
      title: 'Account',
      meta: {
        short_description: 'Associated Zoho account',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.zohosign_deal': {
      sql: 'zohosign_deal',
      type: 'string',
      title: 'Deal',
      meta: {
        short_description: 'Associated Zoho deal/campaign ID',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.insertion_order': {
      sql: 'insertion_order',
      type: 'string',
      title: 'Insertion Order',
      meta: {
        short_description: 'Associated insertion order ID',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.agency': {
      sql: 'agency',
      type: 'string',
      title: 'Agency',
      meta: {
        short_description: 'Agency name on the document',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry,
    'zohosign_documents.modified_time': {
      sql: 'modified_time',
      type: 'time',
      title: 'Modified Time',
      meta: {
        short_description: 'Last modified timestamp from Zoho CRM',
        source_tables: ['media_tool.zohosign_documents']
      }
    } as const satisfies CubeDimensionEntry
  }
};
